import { render, staticRenderFns } from "./ProofItemPage.vue?vue&type=template&id=62de24bc&scoped=true&"
import script from "./ProofItemPage.vue?vue&type=script&lang=js&"
export * from "./ProofItemPage.vue?vue&type=script&lang=js&"
import style0 from "./ProofItemPage.vue?vue&type=style&index=0&id=62de24bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62de24bc",
  null
  
)

export default component.exports